// extracted by mini-css-extract-plugin
module.exports = {"carousel":"ListPresentation_carousel__lyRBR","group":"ListPresentation_group___ECsm","scrolling":"ListPresentation_scrolling__8grpZ"};